import React from 'react';
import AuthForm from './shared/AuthForm';
import LocationAutocomplete from '../../../components/LocationAutocomplete';

const fields = [
    {
      name: 'city',
      label: 'CITY*',
      component: LocationAutocomplete,
      searchOptions: { types: ['(cities)'] },
      confirmOnSelect: true,
      needFullAddress: true,
      displayKey: 'fullAddress',
      showPin: true,
      needBounds: true,
    },
]

function RegisterClient() {
    return (
        <>
            <div className="auth-page">
                <div className="image-container-new"></div>
                <div className="auth-container">
                    <AuthForm
                        fields={fields}
                        submitStyle='login-btn'
                    />
                </div>
            </div>
        </>
        );
}

export default RegisterClient;